import React from "react";

import TextCheckBox from "components/common/TextCheckBox";

import "./PermissionPicker.scss";

// catalog: [{ key, name, permissions: [{ permissionId, key, action, name, userTypes, customerGrantable }] }]
// value: string[] of permission keys; onChange(nextKeys)
export default function PermissionPicker({ catalog, userType, value, onChange }) {
  const selected = value || [];

  const toggle = (permKey) => {
    const next = selected.includes(permKey)
      ? selected.filter((k) => k !== permKey)
      : [...selected, permKey];
    onChange(next);
  };

  // Filter each feature's permissions to those applicable to the selected userType,
  // then hide features that end up with zero applicable permissions.
  const features = (catalog || [])
    .map((feature) => ({
      ...feature,
      permissions: (feature.permissions || []).filter(
        (perm) => !userType || (perm.userTypes || []).includes(userType)
      ),
    }))
    .filter((feature) => feature.permissions.length > 0);

  if (features.length === 0) {
    return (
      <p className="para-body-s-regular permission-picker__empty">
        {userType ? "No permissions available for this user type." : "Select a user type to view permissions."}
      </p>
    );
  }

  return (
    <div className="permission-picker">
      {features.map((feature) => (
        <div key={feature.key} className="permission-picker__feature">
          <p className="para-body-m-medium permission-picker__feature-heading">{feature.name}</p>
          <div className="permission-picker__options">
            {feature.permissions.map((perm) => (
              <TextCheckBox
                key={perm.key}
                text={perm.name || perm.key}
                checked={selected.includes(perm.key)}
                onChange={() => toggle(perm.key)}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
